/* unplugin-vue-components disabled */import { render } from "./MarketUVFExchange.vue?vue&type=template&id=625aeb4f"
import script from "./MarketUVFExchange.vue?vue&type=script&lang=js"
export * from "./MarketUVFExchange.vue?vue&type=script&lang=js"

import exportComponent from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__